import { ActivityNotifier } from '@rss-engineering/fabric-ui-session';

/**
 * Activity notifier will try to keep a session alive and log user out when session expires
 * @see https://github.com/RSS-Engineering/fabric-ui-session#activitynotifieroptions
 */

const sessionActivityNotifier = new ActivityNotifier();
sessionActivityNotifier.run();
sessionActivityNotifier.subscribe(((success: boolean) => {
  if (!success) {
    // eslint-disable-next-line no-console
    console.warn('could not extend session');
  }
}));

export default sessionActivityNotifier;
